export default "__VITE_PUBLIC_ASSET__fc50cb30__"